export enum Routes {
  Main = 'main',
  Cart = 'cart',
  OrderDetails = 'order_details',
  Checkout = 'checkout',
  Payment = 'payment',
  GiftCardOrderDetails = 'gift_cards/order_details',
  GiftCardCheckout = 'gift_cards/checkout',
  UploadGoogleReview = 'upload_google_review',
  RewardDetails = 'reward_details',
  Rewards = 'rewards',
}

export enum Tabs {
  Home = 'home',
  Menu = 'menu',
  Orders = 'orders',
}

export enum Modals {
  AddCreditCard = 'add_credit_card',
  AddAdyenCard = 'add_adyen_card',
  Profile = 'profile',
  PaymentMethods = 'payment_methods',
  ManageAccount = 'manage_account',
  HelpAndFAQs = 'help_and_faqs',
  Logout = 'logout',
  OrderMethod = 'order_method',
  Location = 'location',
  DateTime = 'date_time',
  DeliveryAddress = 'delivery_address',
  Signup = 'signup',
  Login = 'login',
  MenuItem = 'menu_item',
  OrderTracker = 'order_tracker',
  LanguageSwitcher = 'language_switcher',
  OfferModal = 'offer_modal',
  MultiPromoCode = 'multi_promo_code',
  FreeItemsModal = 'free_items_modal',
  MobileAppSignupBonus = 'mobile_app_signup_bonus',
  BuyGiftCardModal = 'buy_gift_card_modal',
}

export enum FeatureFlags {
  AppReview = 'app_review',
}
